<template>
    <div>
        <crumbTab :tabList="tabList" />
        <div v-show="!showContent" class="recent-report">
            <div class="report-title">
                <sampleSelector :menus-list="['全部日期', ...yearList]" :select-item="selectItem" @changeItem="changeItem"></sampleSelector>
                <div class="search">
                    <input v-model="keyStr" class="search-input" type="text" placeholder="输入关键词" />
                    <button type="button" class="search-btn" @click="search">搜索</button>
                </div>
            </div>
            <div class="list">
                <div v-for="item in newsList" v-show="item.matchData && item.matchData.length" :key="item.year" class="year-list">
                    <div class="year-title">{{ item.year }}</div>
                    <div v-for="child in item.matchData" :key="child.title" class="news-item" @click="showRecentContent(child)">
                        <div class="news-title">{{ child.title }}</div>
                        <div class="news-date">{{ child.newsTime }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="showContent" class="content-wrap">
            <div class="ck-content" v-html="content" />
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import crumbTab from './components/crumb-tab.vue'
import sampleSelector from './components/sample-selector.vue'

export default {
    name: 'RecentList',
    components: { crumbTab, sampleSelector },
    data() {
        return {
            tabList: [
                { content: '首页', url: '/cn/sc/prd/investor' },
                { content: '业绩推介', url: '/cn/sc/prd/investor/report' },
                { content: '近期要闻', url: '/cn/sc/prd/investor/recent-list' }
            ],
            initData: [],
            newsList: [],
            yearList: [],
            selectItem: '全部日期',
            showContent: false,
            content: '',
            keyStr: ''
        }
    },
    computed: {},
    async created() {
        const RecentHighlightsRes = await ajax.investorRecentHighlights()
        const {
            yearList: { arr }
        } = RecentHighlightsRes
        const newsRes = await ajax.investorNews({ params: { _sort: 'newsTime:DESC' } })
        const newsList = []
        this.yearList = arr
        arr.forEach(item => {
            const matchData = newsRes.filter(listItem => String(listItem.year) === String(item))
            newsList.push({
                year: item,
                data: matchData,
                matchData
            })
        })
        this.newsList = newsList
        this.initData = newsList
        if (this.$route.query.id) {
            const item = newsRes.find(item => String(item.id) === String(this.$route.query.id))
            this.showRecentContent(item)
        } else {
            window.addEventListener('popstate', this.handle, false)
        }
        window.scrollTo({
            top: 0
        })
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.handle)
    },
    methods: {
        // 近期要闻-切换内容展示
        showRecentContent(item) {
            if (item && item.content) {
                this.showContent = true
                this.content = item.content
                if (!this.$route.query.id) {
                    window.history.pushState(null, null, '')
                }
                window.scrollTo({ top: 0 })
            }
        },
        changeItem(item) {
            this.selectItem = String(item)
        },
        search() {
            let tempYearList = []
            if (this.selectItem === '全部日期') {
                tempYearList = this.initData
            } else {
                tempYearList = [this.initData.find(item => String(item.year) === String(this.selectItem))]
            }
            if (this.keyStr) {
                tempYearList.forEach(item => {
                    item.matchData = item.data.filter(newsItem => newsItem.title.includes(this.keyStr))
                })
            } else {
                tempYearList.forEach(item => {
                    item.matchData = item.data
                })
            }
            this.newsList = tempYearList
        },
        handle() {
            if (this.showContent) {
                this.showContent = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.recent-report {
    display: flex;
    flex-direction: column;
    .report-title {
        margin-top: 40px;
        .search {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 40px;
            margin-top: 30px;
            .search-input {
                width: 470px;
                height: 80px;
                color: #333;
                padding: 25px 21px;
                padding-left: 65px;
                margin-right: 20px;
                border: 1px solid #999999;
                border-radius: 10px;
                background: #fff;
                font-size: 28px;
                background-image: url('~@/assets/images/investorRelation/search.png');
                background-repeat: no-repeat;
                background-size: 30px;
                background-position: 20px center;
            }
            .search-btn {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 80px;
                background: #ce0e2d;
                border: none;
                font-weight: 400;
                font-size: 28px;
                color: #fff;
                border-radius: 10px;
            }
        }
    }
    .report-content {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .list {
        padding: 0 40px;
        margin-top: 40px;
        .year-list {
            margin-bottom: 60px;
            .year-title {
                padding: 30px 0;
                font-size: 28px;
                color: #333333;
                border-bottom: solid 2px #dc1e32;
            }

            .news-item {
                padding: 30px 0;
                font-size: 26px;
                color: #333333;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: solid 1px #f0f0f0;
                .news-title {
                    flex: 1;
                    margin-right: 5px;
                }
                .news-date {
                    color: #dc1e32;
                    width: 150px;
                    text-align: right;
                    white-space: nowrap;
                }
            }
        }
    }
}

.content-wrap {
    padding: 20px;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/recent-list.vue